import React from 'react'
import whyLoansnap from '../img/WhyLoansnap_phone_crop_no_cartoon_no_text.svg'
import loPicture from '../../static/img/loanflow/testimonies/michelle.png'
import loanSnapLogo from '../../static/img/icons/LoanSnap_Brandmark_no-padding.svg'
import { presets, colors } from '../utils/theme'

const styles = {
  halfRow: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    position: 'relative',
    marginTop: '4rem',
  },
  phone: {
    position: 'relative',
    width: '100%',
    maxWidth: '316px',
    margin: 0,
    zIndex: 0,
  },
  lo: {
    zIndex: 1,
    width: '4.5rem',
    position: 'absolute',
    marginLeft: '5rem',
  },
  chatBox: {
    top: '5rem',
    zIndex: 1,
    position: 'absolute',
  },
  messageContainer: {
    backgroundColor: colors.veryLightGrey,
    borderRadius: '10px',
    width: '12.6rem',
    marginRight: '0.3rem',
    padding: '0.7rem 0.7rem 0.4rem 0.7rem',
    color: colors.grey,
  },
  textHeader: {
    fontWeight: 400,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.4rem',
    fontSize: '0.62rem',
  },
  loansnapLogoAndTextContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  loansnapLogo: {
    width: '1rem',
    marginBottom: 0,
    marginRight: '0.4rem',
  },
  message: {
    fontSize: '0.72rem',
    fontWeight: 600,
    textAlign: 'justify',
  },
  triangle: {
    margin: '-0.5rem auto 0 auto',
    width: 0,
    height: 0,
    borderTop: '2px solid transparent',
    borderBottom: '25px solid transparent',
    borderRight: '25px solid #F9F9F9',
    transform: 'rotate(-10deg)',
  },
}

export const WhyLoanSnap = ({subTextLines, loMessage}) => {
  const hasMultipleLines = subTextLines && subTextLines.length > 1
  return (
    <div css={[styles.halfRow, {alignItems: 'center', display: 'none', [presets.Tablet]: { display: 'flex'}}]}>
      <img alt="whyLoansnap" src={whyLoansnap} css={[styles.phone, { maxWidth: hasMultipleLines ? '370px' : '316px'}]}/>
      <div css={styles.chatBox}>
        <div css={styles.messageContainer}>
          <div css={styles.textHeader}>
            <div css={styles.loansnapLogoAndTextContainer}>
              <img src={loanSnapLogo} alt='LoanSnap Logo'  css={[styles.loansnapLogo]}/>
              <div>LOANSNAP</div>
            </div>
            <div>now</div>
          </div>
          <div css={styles.message}>{loMessage}</div>
        </div>
        <div css={styles.triangle}></div>
      </div>
      <img src={loPicture} alt='Loan Officer Picture'  css={[styles.lo, {bottom: hasMultipleLines ? '2rem' : '1rem'}]}/>
    </div>
  )
}